import { FeatureFlag } from '../FeatureFlag';

export const enableIdeaAlerts = new FeatureFlag({
    key: 'enable-idea-alerts',
    defaultValue: false,
});
